mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    id
    status
    progress
  }
}
